export const getActions = (item, user) => {
    const actions = {
            actions: [
            {
                label: 'Ver detalles',
                icon: 'details',
                action: 'details'
            },
            {
                label: 'Descargar PDF',
                icon: 'pdf',
                action: 'download'
            },
            {
                label: 'Duplicar',
                icon: 'duplicate',
                action: 'clone'
            }
        ],
        extra: []
    };

    if(!item.es_venta) {
        actions.actions.push({
            label: 'Generar venta',
            icon: 'pay',
            action: 'generate'
        })
    }

    if(item.expirado) {
        actions.actions.push({
            label: 'Reactivar',
            icon: 'enable',
            action: 'enable'
        })
    }

    if(!item.expirado && !item.es_venta) {
        actions.actions.push({
            label: 'Desactivar',
            icon: 'disable',
            action: 'disable'
        })
    }

    if(((!item.validado && (user.responsable || user.rol_id === 1)) || (item.validado_integracion === false && (user.responsable || user.rol_id === 1)))) {
        actions.actions.push({
            label: 'Validar',
            icon: 'check',
            action: 'validate'
        })
    }

    if(!item.ticket_id) {
        actions.actions.push({
            label: 'Asignar ticket',
            icon: 'check',
            action: 'assign-ticket'
        })
    } else {
        actions.actions.push({
            label: 'Desasignar ticket',
            icon: 'cancel',
            action: 'unassign-ticket'
        })
    }

    return actions;
}